var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "form",
        {
          attrs: { action: "/" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.load.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "btn-group btn-group-toggle",
                  attrs: { "data-toggle": "buttons" },
                },
                [
                  _vm._l(_vm.mainRunnersList, function (city, index) {
                    return [
                      _c(
                        "label",
                        {
                          class: [
                            { active: _vm.params.mainRunner == city.id },
                            "btn btn-outline-primary",
                          ],
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.params.mainRunner,
                                expression: "params.mainRunner",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              name: "mainRunnerSelected",
                              autocomplete: "off",
                              checked: "",
                            },
                            domProps: {
                              value: city.id,
                              checked: _vm._q(_vm.params.mainRunner, city.id),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  return _vm.$set(
                                    _vm.params,
                                    "mainRunner",
                                    city.id
                                  )
                                },
                                function ($event) {
                                  return _vm.load(1, true)
                                },
                              ],
                            },
                          }),
                          _vm._v(" " + _vm._s(city.title) + "\n              "),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex filters-wrap" }, [
              _c("div", { staticClass: "form-group date_range" }, [
                _c("label", [_vm._v("Дата")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("datetime", {
                      attrs: {
                        "input-id": "startDate",
                        "input-class": "form-control",
                        type: "date",
                        "minute-step": 60,
                        format: "dd.MM.yyyy",
                        auto: true,
                        "use-utc": true,
                        "max-datetime": _vm.max_date,
                      },
                      model: {
                        value: _vm.params.report_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.params, "report_date", $$v)
                        },
                        expression: "params.report_date",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group date_range" }, [
                _c("label", [_vm._v("Курьер")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _vm.couriers
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.params.courier,
                              expression: "params.courier",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.params,
                                "courier",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("- все -"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.couriers, function (courier, key) {
                            return _c("option", { domProps: { value: key } }, [
                              _vm._v(_vm._s(courier)),
                            ])
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        type: "submit",
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.loading,
                      },
                    },
                    [_vm._v("Поиск\n            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.reports
      ? _c("div", [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", {
                    staticClass: "summryReport",
                    domProps: { innerHTML: _vm._s(_vm.printCashCalculation()) },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", [
                    _c("div", [
                      _c("h6", [
                        _vm._v("Отчет по прибыли "),
                        _vm.reports
                          ? _c("span", [
                              _vm._v("(заявок: "),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.reports.length)),
                              ]),
                              _vm._v(")"),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Текущий курс: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.currenciesRates[33]) +
                              "\n                  (" +
                              _vm._s(
                                Math.round(
                                  (1 / _vm.currenciesRates[33]) * 100
                                ) / 100
                              ) +
                              ")"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "Общая выручка (за минусом зарплаты и расходов)\n                  "
                        ),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.reportData.totalPriceEUR.toLocaleString(
                                "ru-RU"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" EUR"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("Себестоимость "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.reportData.cost.toLocaleString("ru-RU"))
                          ),
                        ]),
                        _vm._v(" EUR"),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm.params.mainRunner && _vm.params.mainRunner != 0
                          ? _c("span", [
                              _vm._v(
                                "\n                    Расходы по текущему складу\n                  "
                              ),
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                    Всего расходов\n                  "
                              ),
                            ]),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.reportData.totalExpenses.toLocaleString(
                                "ru-RU"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" EUR\n                "),
                      ]),
                      _vm._v(" "),
                      _vm.params.mainRunner && _vm.params.mainRunner != 0
                        ? _c("p", [
                            _vm._v(
                              "Пропорциональная часть общих расходов\n                  "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.reportData.sharedExpenses.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" EUR"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("ИТОГО прибыль "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.reportData.clearedIncome.toLocaleString(
                                "ru-RU"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" EUR"),
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _vm.cardsIncome.length
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                "all: " + _vm._s(_vm.pastOrdersStat.price)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "salary: " + _vm._s(_vm.pastOrdersStat.salary)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "post: " +
                                  _vm._s(_vm.pastOrdersStat.total_post_sum)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "расходы за период: " +
                                  _vm._s(_vm.expensesBWIncomes)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "к сдаче: " + _vm._s(_vm.pastOrdersStat.toOut)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Снятая сумма: " +
                                  _vm._s(this.cardsIncome[0].sum) +
                                  " + (старый конверт)\n                    " +
                                  _vm._s(
                                    (this.cardsIncome[1] &&
                                      this.cardsIncome[1].envelope) ||
                                      0
                                  ) +
                                  " = " +
                                  _vm._s(
                                    this.cardsIncome[0].sum +
                                      ((this.cardsIncome[1] &&
                                        this.cardsIncome[1].envelope) ||
                                        0)
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "С БД текущий конверт (старая версия): " +
                                  _vm._s(this.cardsIncome[0].envelope)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Новый конверт (на основе суммы инкассации - расчетный): " +
                                  _vm._s(
                                    this.cardsIncome[0].sum +
                                      ((this.cardsIncome[1] &&
                                        this.cardsIncome[1].new_envelope) ||
                                        0) -
                                      _vm.pastOrdersStat.salary -
                                      _vm.pastOrdersStat.total_post_sum -
                                      _vm.getAllCashOut()
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Предидущий конверт (новый подсчет):\n                    " +
                                  _vm._s(
                                    (this.cardsIncome[1] &&
                                      this.cardsIncome[1].new_envelope) ||
                                      0
                                  )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "Delta: " + _vm._s(this.cardsIncome[0].diff)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hidden col-md-6 sticky_report" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h5", [
                    _vm._v(
                      "Расчет RUB " +
                        _vm._s(
                          _vm.moment(_vm.params.report_date, "DD.MM.YYYY")
                        ) +
                        " "
                    ),
                    _c("span", [
                      _c("i", {
                        staticClass: "icon-fa icon-fa-angle-down",
                        class: { open: _vm.activeCashData },
                        on: {
                          click: function ($event) {
                            _vm.activeCashData = !_vm.activeCashData
                          },
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card-body cashData",
                    class: { active: _vm.activeCashData },
                  },
                  [
                    _vm.totalYesterdayFigures
                      ? _c("div", [
                          _c("p", [
                            _vm._v("Сальдо прошлого дня: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.printCashCalculation(true))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.detailedIncomes.in
                            ? _c("p", [
                                _vm._v("Входящие инкассации\n                "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getTotalFigures(
                                        _vm.detailedIncomes.in
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" руб.\n                "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: _vm.getInfoByList(
                                          _vm.detailedIncomes.in
                                        ),
                                        placement: "bottom-center",
                                        classes: ["info custom-tooltip"],
                                        targetClasses: [
                                          "it-has-a-tooltip custom-tooltip",
                                        ],
                                        offset: 10,
                                        delay: {
                                          show: 200,
                                          hide: 700,
                                        },
                                      },
                                      expression:
                                        "{\n                      content: getInfoByList(detailedIncomes.in),\n                      placement: 'bottom-center',\n                      classes: ['info custom-tooltip'],\n                      targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                      offset: 10,\n                      delay: {\n                        show: 200,\n                        hide: 700,\n                      },\n                    }",
                                    },
                                  ],
                                  staticClass:
                                    "icon-fa icon-fa-info-circle comment_tooltip_fa",
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.detailedIncomes.out
                            ? _c("p", [
                                _vm._v(
                                  "Исходящие инкассации\n                "
                                ),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getTotalFigures(
                                        _vm.detailedIncomes.out
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" руб.\n                "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: _vm.getInfoByList(
                                          _vm.detailedIncomes.out
                                        ),
                                        placement: "bottom-center",
                                        classes: ["info custom-tooltip"],
                                        targetClasses: [
                                          "it-has-a-tooltip custom-tooltip",
                                        ],
                                        offset: 10,
                                        delay: {
                                          show: 200,
                                          hide: 700,
                                        },
                                      },
                                      expression:
                                        "{\n                      content: getInfoByList(detailedIncomes.out),\n                      placement: 'bottom-center',\n                      classes: ['info custom-tooltip'],\n                      targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                      offset: 10,\n                      delay: {\n                        show: 200,\n                        hide: 700,\n                      },\n                    }",
                                    },
                                  ],
                                  staticClass:
                                    "icon-fa icon-fa-info-circle comment_tooltip_fa",
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.detailedExpenses && _vm.detailedExpenses.length
                            ? _c("p", [
                                _vm._v("Расходы\n                "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getTotalFigures(_vm.detailedExpenses)
                                    )
                                  ),
                                ]),
                                _vm._v(" руб.\n                "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: _vm.getInfoByList(
                                          _vm.detailedExpenses,
                                          true
                                        ),
                                        placement: "bottom-center",
                                        classes: ["info custom-tooltip"],
                                        targetClasses: [
                                          "it-has-a-tooltip custom-tooltip",
                                        ],
                                        offset: 10,
                                        delay: {
                                          show: 200,
                                          hide: 700,
                                        },
                                      },
                                      expression:
                                        "{\n                      content: getInfoByList(detailedExpenses, true),\n                      placement: 'bottom-center',\n                      classes: ['info custom-tooltip'],\n                      targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                      offset: 10,\n                      delay: {\n                        show: 200,\n                        hide: 700,\n                      },\n                    }",
                                    },
                                  ],
                                  staticClass:
                                    "icon-fa icon-fa-info-circle comment_tooltip_fa",
                                }),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Сумма по сегодняшним заявкам (минус зарплаты и расходы):\n                "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.reportData.totalPrice.toLocaleString(
                                    "ru-RU"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("ИТОГО "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.printCashCalculation(false, true))
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c(
                    "div",
                    [
                      _c("expenses", {
                        attrs: {
                          expenses: _vm.detailedExpenses,
                          allExpensesTypes: _vm.allExpensesTypes,
                          userId: _vm.params.mainRunner,
                          expensesTypes: _vm.expensesTypes,
                          allowedExpenses: _vm.allowedExpenses,
                          currencies: _vm.currencies,
                          date: this.currentReportDate,
                          storeId: _vm.currentStoreId,
                          storeNames: _vm.storesList,
                          users: _vm.involvedUsers,
                          updateExpenses: _vm.updateExpenses,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              this.params.mainRunner
                ? _c("div", { staticClass: "card" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        [
                          _c("currencyBuy", {
                            attrs: {
                              currenciesDeals: _vm.currencyExchanges,
                              currencies: _vm.currencies,
                              userId: _vm.params.mainRunner,
                              date: _vm.moment(
                                _vm.params.report_date,
                                "YYYY-MM-DD"
                              ),
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _vm.detailedIncomes.out && _vm.detailedIncomes.out.length
                    ? _c("div", [
                        _c(
                          "table",
                          { staticClass: "table table-sm table-hover" },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.detailedIncomes.out,
                                function (income, index) {
                                  return _c("tr", [
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          income.user
                                            ? income.user.name
                                            : _vm.getCurrentMainRunner()
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(income.sum))]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currencies[income.currency_id]
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moment(
                                            income.created_at,
                                            "DD.MM.YYYY"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.moment(
                                            income.created_at,
                                            "DD.MM HH:mm"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        income.pass_date
                                          ? [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.moment(
                                                    income.pass_date,
                                                    "DD.MM.YYYY"
                                                  )
                                                )
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(income.comment))]),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("income", {
                        attrs: {
                          updateIncomes: _vm.updateIncomes,
                          userId: _vm.params.mainRunner,
                          reportDate: _vm.currentReportDate,
                          toUsers: _vm.moneyOutUsers,
                          date: _vm.moment(
                            _vm.params.report_date,
                            "YYYY-MM-DD"
                          ),
                          currencies: _vm.currencies,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.detailedIncomes.in && _vm.detailedIncomes.in.length
                  ? _c("div", { staticClass: "card-body" }, [
                      _c("h5", [_vm._v("Входящие инкассации")]),
                      _vm._v(" "),
                      _c(
                        "table",
                        { staticClass: "table table-sm table-hover" },
                        [
                          _vm._m(6),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(
                              _vm.detailedIncomes.in,
                              function (record, index) {
                                return _c("tr", [
                                  _c("td", [_vm._v(_vm._s(index + 1))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(record.user.name))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(record.comment))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        record.receiver && record.receiver.name
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(record.sum))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.currencies[record.currency_id])
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(record.created_at))]),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: !_vm.reports },
                }),
                _vm._v(" "),
                _vm.reports && _vm.reports.length
                  ? _c(
                      "table",
                      {
                        staticClass:
                          "table table-bordered1 table-hover table-style-1",
                      },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Номер")]),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("th", [
                                  _vm._v("Время доставки"),
                                  _c("br"),
                                  _vm._v("Бандероль"),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("th", [_vm._v("Препараты")])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-right" }, [
                              _vm._v("Сумма"),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-right" }, [
                              _vm._v("З/п"),
                            ]),
                            _vm._v(" "),
                            !_vm.clearedView && _vm.isPostFieldDisplayed()
                              ? _c("th", { staticClass: "text-right" }, [
                                  _vm._v("Почтовы р."),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-right" }, [
                              _vm._v("К сдаче"),
                            ]),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("th", [_vm._v("Адрес")])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("th", [_vm._v("Курьер")])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            !_vm.clearedView
                              ? _c("tr", { staticClass: "tr-highlighted" }, [
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        colspan: _vm.isPostFieldDisplayed()
                                          ? 3
                                          : 2,
                                      },
                                    },
                                    [_vm._v("Итого")]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalFigures.sumAll)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalFigures.sumSalary)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isPostFieldDisplayed()
                                    ? _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(_vm.totalFigures.sumPostExp)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalFigures.sumNeedle)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "2" } }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.sortedByField(_vm.reports, "report_date"),
                              function (report, key) {
                                return _c("tr", { key: key }, [
                                  _c(
                                    "td",
                                    [
                                      _vm.clearedView
                                        ? [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(report.id) +
                                                "\n              "
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: `/orders/edit/${report.id}`,
                                                },
                                              },
                                              [_vm._v(_vm._s(report.id))]
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.moment(
                                                    report.report_date,
                                                    "DD.MM.YYYY HH:mm"
                                                  )
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                _vm._s(report.status_label)
                                              ),
                                            ]),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  !_vm.clearedView
                                    ? _c("td", [
                                        _c("b", [
                                          _vm._v(_vm._s(report.project_label)),
                                        ]),
                                        _c("br"),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.moment(
                                                report.delivery_date,
                                                "DD.MM.YYYY HH:mm"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        _c("div", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.printPostTrack(report)
                                            ),
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.clearedView
                                    ? _c("td", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.displayDrugs(report.details)
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(report.price)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(report.courier_salary)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isPostFieldDisplayed()
                                    ? _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            report.extra_options["post_sum"] ||
                                              0
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(report.needle_sum)),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.clearedView
                                    ? _c("td", [
                                        _c(
                                          "div",
                                          { staticClass: "drug_price_details" },
                                          [_vm._v(_vm._s(report.address))]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.clearedView
                                    ? _c("td", [
                                        _vm._v(_vm._s(report.courier_name)),
                                      ])
                                    : _vm._e(),
                                ])
                              }
                            ),
                            _vm._v(" "),
                            !_vm.clearedView
                              ? _c("tr", { staticClass: "tr-highlighted" }, [
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        colspan: _vm.isPostFieldDisplayed()
                                          ? 4
                                          : 3,
                                      },
                                    },
                                    [_vm._v("Итого")]
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalFigures.sumAll)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalFigures.sumSalary)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.isPostFieldDisplayed()
                                    ? _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(_vm.totalFigures.sumPostExp)
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-right" }, [
                                    _vm._v(_vm._s(_vm.totalFigures.sumNeedle)),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { attrs: { colspan: "2" } }),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.reports && !_vm.reports.length
                  ? _c("div", [
                      _vm._v("\n          Ничего не найдено\n        "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card" }, [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: !_vm.rejected },
                }),
                _vm._v(" "),
                _vm.rejected && _vm.rejected.length
                  ? _c(
                      "table",
                      {
                        staticClass:
                          "table table-bordered1 table-hover table-style-1",
                      },
                      [
                        _vm._m(8),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.rejected, function (report, key) {
                              return _c("tr", { key: key }, [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `/orders/edit/${report.id}`,
                                      },
                                    },
                                    [_vm._v(_vm._s(report.id))]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(report.report_date)),
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(report.status_label)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("b", [
                                    _vm._v(_vm._s(report.project_label)),
                                  ]),
                                  _c("br"),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(report.report_time) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.displayDrugs(report.details)
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(_vm._s(report.price)),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "div",
                                    { staticClass: "drug_price_details" },
                                    [_vm._v(_vm._s(report.address))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      report.courier_name || "не распределен"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(report.reject_comment)),
                                ]),
                              ])
                            }),
                            _vm._v(" "),
                            _vm._m(9),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.rejected && !_vm.rejected.length
                  ? _c("div", [
                      _vm._v("\n          Ничего не найдено\n        "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Сальдо")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Ежедневный отчет")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Расходы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Покупка валюты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Инкассации")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Старший курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Валюта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th", [_vm._v("Время внесения")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата проведения")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Пользователь")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
        _vm._v(" "),
        _c("th", [_vm._v("Получатель")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Валюта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Отказы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Время доставки")]),
        _vm._v(" "),
        _c("th", [_vm._v("Препараты")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Адрес")]),
        _vm._v(" "),
        _c("th", [_vm._v("Курьер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Отказ")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticClass: "tr-highlighted hidden" }, [
      _c("td", { attrs: { colspan: "3" } }, [_vm._v("Итого")]),
      _vm._v(" "),
      _c("td", { staticClass: "text-right" }, [_vm._v("main.sum.rejected")]),
      _vm._v(" "),
      _c("td", { attrs: { colspan: "3" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }